import React from "react";
import { observer } from "mobx-react";
import { Divider, Stack } from "@chakra-ui/react";
import { translations } from "@/constants/translations";
import { useStore } from "@/store";
import { OrderConfirmedPanel } from "./OrderConfirmedPanel";
import { renderInnerHtml } from "@/helpers/dom";
import { H2, H3 } from "@/components/Heading";
import { useEffectOnce } from "usehooks-ts";
import { telemetry } from "@/telemetry";
import { paymentMethods } from "@/telemetry/events";

export const OrderConfirmationPage = observer(() => {
  const { activeLanguage, orderData, orderValidatedData, orderCreatedData } =
    useStore();

  const language = translations.pages["order-confirm"][activeLanguage];

  useEffectOnce(() =>
    telemetry.trackEvent("order_confirmed_viewed", {
      order_id: orderCreatedData?.orderId,
      method: paymentMethods[orderData.purchaseType],
    }),
  );

  return (
    <OrderConfirmedPanel>
      <Stack
        spacing={{ base: 7, md: 14 }}
        alignItems="center"
        textAlign="center"
      >
        <H2>{renderInnerHtml(language.thank_your_order_placed)}</H2>
        <Stack spacing="8">
          {orderValidatedData?.orderId && (
            <Stack>
              <H3>{renderInnerHtml(language.order_confirmation)}</H3>
              <H3 color="primary-light">{orderValidatedData?.orderId}</H3>
            </Stack>
          )}
          <Stack>
            <H3>{renderInnerHtml(language.a_confirmation_email)}</H3>
            <H3 color="primary-light">{orderData.emailAddress}</H3>
          </Stack>
        </Stack>
        <Divider />
      </Stack>
    </OrderConfirmedPanel>
  );
});
